import { useState } from "react";
import {
  getProcurementActionLabel,
  getProcurementActionsForStatus,
} from "./procurementOrderActionConfig";

export default function ProcurementOrderReceivePanel({ type, status, onSubmit, loading = false }) {
  const [note, setNote] = useState("");
  const allowedActions = getProcurementActionsForStatus(status).filter((action) =>
    ["receive_partial", "receive"].includes(action)
  );

  if (allowedActions.length === 0) return null;

  return (
    <div className="rounded-xl border border-slate-200 bg-white p-4">
      <h3 className="text-sm font-semibold text-slate-900">Ontvangst / uitvoering</h3>
      <p className="mt-1 text-xs text-slate-500">
        {type === "service_order"
          ? "Bevestig uitvoering van externe opdracht."
          : "Markeer materiaalorder als deels of volledig ontvangen."}
      </p>
      <textarea
        value={note}
        onChange={(e) => setNote(e.target.value)}
        rows={2}
        placeholder="Ontvangstnotitie (optioneel)"
        className="mt-3 w-full rounded-lg border border-slate-200 px-3 py-2 text-sm"
      />
      <div className="mt-3 flex flex-wrap gap-2">
        {allowedActions.map((actionKey) => (
          <button
            key={actionKey}
            type="button"
            disabled={loading}
            onClick={() => onSubmit?.(actionKey, note)}
            className={
              actionKey === "receive"
                ? "rounded-lg border border-emerald-200 bg-emerald-50 px-3 py-1.5 text-xs text-emerald-700 disabled:opacity-60"
                : "rounded-lg border border-slate-200 bg-white px-3 py-1.5 text-xs text-slate-700 disabled:opacity-60"
            }
          >
            {actionKey === "receive"
              ? "Volledig ontvangen"
              : getProcurementActionLabel(actionKey)}
          </button>
        ))}
      </div>
    </div>
  );
}
